import { styled, useTheme } from "@mui/material";
import { FunctionComponent } from "react";
import { useConfiguration } from "../../dataAccess/api/configuration";
import CustomHTML from "./CustomHTML";
import OnlyDesktop from "./OnlyDesktop";
import StaticGraphic from "./StaticGraphic";

const GraphicContainer = styled(OnlyDesktop)(({ theme }) => {
  const isCenterAlignment = theme.settings.lockScreens.alignment === "center";
  const isLeftAlignment = theme.settings.lockScreens.alignment === "left";

  return {
    [theme.breakpoints.up("md")]: {
      width: "40%",
      backgroundColor: theme.palette.primary.main,
      flexDirection: "column",
      alignItems: isLeftAlignment ? "flex-end" : "flex-start",
      display: isCenterAlignment ? "none" : "flex",
    },
  };
});

const AccountsGraphic: FunctionComponent = () => {
  const theme = useTheme();
  const { configuration } = useConfiguration();
  const { html, variant, backgroundColor, textColor } =
    theme.settings.lockScreens.graphic;
  const getComponentByVariant = (settingsVariant: typeof variant) => {
    const htmlCode = html || "";
    if (settingsVariant === "html") {
      return <CustomHTML html={htmlCode} />;
    }
    if (settingsVariant === "static") {
      return (
        <StaticGraphic
          backgroundColor={backgroundColor}
          description={configuration?.description}
          textColor={textColor}
          marketplaceName={configuration?.name}
          logo={configuration?.signUpLogoUrl}
          title={configuration?.tagline}
        />
      );
    }
  };

  return <GraphicContainer>{getComponentByVariant(variant)}</GraphicContainer>;
};

export default AccountsGraphic;
